import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import * as api from '../../api';
import * as actions from './actions';

export function* getTeachers({ productId }) {
    const payload = yield call(api.getTeachersByProduct, productId);
    if (payload.status === 200) {
        yield put(actions.getProductTeachersSuccess(payload));
    } else {
        yield put(actions.getProductTeachersFailure());
    }
}

export function* downloadTeacherRoll(teachers) {
    const response = yield call(api.postTeachersPriorDownload, teachers);
    if (response.status === 201) {
        const downloadUrl = response.verb.url + response.data;
        yield put(actions.downloadTeacherRollSuccess(downloadUrl, true));
    } else {
        yield put(actions.downloadTeacherRollFailure());
    }
}

export function* addTeacher(teacher) {
    const response = yield call(api.addTeacher, teacher);
    if (response.status === 200) {
        yield put(actions.addTeacherSuccess(response.data.userProfileId));
    } else if (response.status === 400 || response.status === 409) {
        yield put(actions.addTeacherFailure(false, response.message));
    } else {
        yield put(actions.addTeacherFailure(true, ''));
    }
}

export function* unassignTeachers({ selectedTeachers, productId }) {
    const userRelationship = { productId, teachersProfileIdToUnassign: selectedTeachers };
    const response = yield call(api.unAssignTeachers, userRelationship);
    if (response.status === 200) {
        yield put(actions.unassignTeachersSuccess());
    } else {
        yield put(actions.unassignTeachersFailure());
    }
}

export function* downloadTeacherSignInCards({ productId, teacherSignInCardsData }) {
    const response = yield call(api.downloadTeachersSignInCards, productId, teacherSignInCardsData);
    if (response.status === 201) {
        const downloadUrl = `${response.verb.url}/${response.data}`;
        yield put(actions.printTeacherSignInCardSuccess(downloadUrl, true));
    } else {
        yield put(actions.printTeacherSignInCardFailure(true));
    }
}

export function* getTeachersSaga() {
    yield takeLatest(actions.GET_PRODUCT_TEACHERS_REQUEST, getTeachers);
}

export function* downloadTeacherRollSaga() {
    yield takeEvery(actions.DOWNLOAD_TEACHER_ROLL_REQUEST, downloadTeacherRoll);
}

export function* unassignTeachersSaga() {
    yield takeLatest(actions.UNASSIGN_TEACHERS_REQUEST, unassignTeachers);
}

export function* downloadSignInCardSaga() {
    yield takeLatest(actions.PRINT_TEACHER_SIGN_IN_CARD_REQUEST, downloadTeacherSignInCards);
}

export function* addTeacherSaga() {
    yield takeLatest(actions.ADD_TEACHER_REQUEST, addTeacher);
}

export function* deleteTeacher(userProfileIds) {
    const userRelationship = { userProfileIds };
    const response = yield call(api.deleteTeachers, userRelationship.userProfileIds);

    if (response.status === 200) {
        const { data } = response;
        yield put(actions.deleteTeacherSuccess(data));
    } else {
        yield put(actions.deleteTeacherFailure());
    }
}

export function* deleteTeacherSaga() {
    yield takeLatest(actions.DELETE_TEACHER_REQUEST, deleteTeacher);
}

export function* sendVerificationEmail(data) {
    const request = { userProfileIds: data.userProfileIds };
    const payload = yield call(api.sendVerificationEmails, request);
    if (payload.status === 200) {
        yield put(actions.sendVerificationEmailSuccess(payload.data));
    } else {
        yield put(actions.sendVerificationEmailFailure(payload.message));
    }
}

export function* sendVerificationEmailSaga() {
    yield takeEvery(actions.SEND_VERIFICATION_EMAIL_REQUEST, sendVerificationEmail);
}



// WEBPACK FOOTER //
// ./app/containers/teacher-roll/saga.js